import { MapContainer, TileLayer } from "react-leaflet";

import { MAP_TILE, MUTED_TILES_CLASS } from "./tiles";

type MapProps = {
  children?: React.ReactNode;
  latitude: number;
  longitude: number;
  zoom?: number;
};

export default function BaseMap({
  children,
  latitude,
  longitude,
  zoom = 15,
}: MapProps) {
  return (
    <MapContainer
      center={[
        typeof latitude === "number" && !isNaN(latitude) ? latitude : 0,
        typeof longitude === "number" && !isNaN(longitude) ? longitude : 0
      ]}
      zoom={zoom}
      className='!h-full !w-full'
      scrollWheelZoom={false}
      zoomControl={false}
      dragging={false}
      doubleClickZoom={false}
      touchZoom={false}
      keyboard={false}
    >
      <TileLayer {...MAP_TILE} className={MUTED_TILES_CLASS} />
      {children}
    </MapContainer>
  );
}
